

import { defineComponent } from 'vue';
import ModalCrud from '../ModalCrud.vue';
import api from '@/api/api';

const DEFAULT_ERR_MSG = 'Falha ao comunicar com o banco de dados!';

export default defineComponent({
    name: 'ModalOndeEstou',
    components: {
        ModalCrud
    },
    props: {
        operation: {
            type: String,
            required: true
        },
        id: {
            type: Number,
            required: false
        },
            presetDataIni: {
            type: String,
            required: false
        },
            presetColaborador: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            data: {
                isLoading: false,
                isValid: false,
                inputs: {
                    dsColaborador: [],
                    dsAtividades: [],
                    dsCliente: [],
                    dsCarro: [],
                    dsRegioes: []
                },
                form: {
                    id: 0,
                    colaborador: 0,
                    cliente: 0,
                    atividade: 0,
                    carro: 0,
                    regiao: 0,
                    dataIni: '',
                    horaIni: '',
                    dataFim: '',
                    horaFim: '',
                    status: 'A',
                    motivoEstorno: '',
                    descricao: ''
                }
            },
            rules: {
                envolveCliente: false,
                envolveCarro: false,
                envolveRegiao: false,
                jaEstornado: false
            },
            inputRules: {
                required: [v => !!v || 'Esse campo precisa ser preenchido.']
            },
            isOpen: true
        }
    },
    methods: {
        async handleSave() {
            try {
                this.data.isLoading = true;

                if (this.$refs.form.validate()) {
                    await api[this.operation]('/compromises', this.data.form);

                    const message = this.operation === 'post' ? 'criado' : 'alterado';
                    this.$toast.success(`Compromisso ${message} com sucesso!`);
                    this.$emit('saved-compromise');
                } else {
                    this.$toast.warning('Formulário inválido! Verifique os dados.');
                };
            } catch (error) {
                this.$toast.error(error.message ?? DEFAULT_ERR_MSG);
            } finally {
                this.data.isLoading = false;
            }
        },
        checkAtividade(codAtividade: number) {
            const atividade = this.data.inputs.dsAtividades.find((x) => x.CODTAREFAEXTERNO === codAtividade);
            this.rules.envolveCliente = atividade.CLIENTE === 'S';
            this.rules.envolveCarro = atividade.CARRO === 'S';
            this.rules.envolveRegiao = atividade.REGIAO === 'S';
        },
        resetCarro() {
            if (this.data.form.carro) {
                this.data.form.carro = 0;
            }
        },
        async loadCarsAvailability() {
            const { id, dataIni, horaIni, dataFim, horaFim } = this.data.form;

            if (!dataIni || !horaIni || !dataFim || !horaFim) return;

            try {
                const response = await api.get('/cars', {
                    params: { ondeEstou: true, id, dataIni, horaIni, dataFim, horaFim }
                });

                this.data.inputs.dsCarro = response.data;
            } catch (error) {
                this.$toast.error(error.message ?? DEFAULT_ERR_MSG);
            }
        }
    },
    computed: {
        dataFimRules() {
            const rules = []
            if (this.data.form.dataIni.length === 0) {
                const rule = v => !!v || 'Data fim precisa ser preenchida.'
                rules.push(rule)
            } else {
                const ruleCheck = (v) => {
                    if (v < this.data.form.dataIni) {
                        return 'Data final não pode ser menor que data inicial.'
                    }
                }
                rules.push(ruleCheck)
            }
            return rules;
        },
        horaFimRules() {
            const rules = []
            if (this.data.form.horaFim.length === 0) {
                const rule = v => !!v || 'Hora fim precisa ser preenchida.'
                rules.push(rule)
            } else {
                if (this.data.form.dataIni === this.data.form.dataFim) {
                    const ruleCheck = (v) => {
                        if (v < this.data.form.horaIni) {
                            return 'Hora final não pode ser menor que hora inicial.'
                        }
                    }
                    rules.push(ruleCheck)
                }
            }
            return rules;
        }
    },
    async mounted() {
        try {
            this.data.isLoading = true;

            const dataFormResponse = await api.get('/compromises/data-form');
            this.data.inputs.dsColaborador = dataFormResponse.data.colaboradores;
            this.data.inputs.dsAtividades = dataFormResponse.data.atividades;
            this.data.inputs.dsCliente = dataFormResponse.data.clientes;
            this.data.inputs.dsCarro = dataFormResponse.data.carros;
            this.data.inputs.dsRegioes = dataFormResponse.data.regioes;

            if (this.operation === 'put') {
                const response = await api.get(`/compromises/${this.id}`);
                this.data.form = {
                    id: response.data.ID,
                    colaborador: response.data.CODCOLABORADOR,
                    cliente: parseInt(response.data.CODCLIENTE),
                    atividade: parseInt(response.data.CODATIVIDADE),
                    carro: parseInt(response.data.CODCARRO),
                    regiao: parseInt(response.data.CODREGIAO),
                    dataIni: response.data.DATAINI,
                    horaIni: response.data.HORAINI,
                    dataFim: response.data.DATAFIM,
                    horaFim: response.data.HORAFIM,
                    status: response.data.CODIGO_STATUS,
                    motivoEstorno: response.data.MOTIVO,
                    descricao: response.data.DESCRICAO
                };

                this.rules.jaEstornado = response.data.CODIGO_STATUS === 'I';
                this.checkAtividade(parseInt(response.data.CODATIVIDADE));
            } else {
                if (this.presetDataIni) {
                    this.data.form.dataIni = this.presetDataIni;
                }
                if (this.presetColaborador) {
                    this.data.form.colaborador = this.presetColaborador;
                }
            }
        } catch (error) {
            this.$toast.error(error.message ?? DEFAULT_ERR_MSG);
        } finally {
            this.data.isLoading = false;
        }
    }
})
